export const GET_REPORT_DATA = 'GET_REPORT_DATA';
export const GET_REPORT_DETAIL_DATA = 'GET_REPORT_DETAIL_DATA';
export const SET_PDF_REPORT_DATA = 'SET_PDF_REPORT_DATA';
export const RESET_REPORT_DATA = 'RESET_REPORT_DATA';
export const RESET_REPORT_DETAIL_DATA = 'RESET_REPORT_DETAIL_DATA';
